<template>
  <div class="privacy-page">
    <div class="privacy-header">
      <h1>隐私协议</h1>
    </div>
    <div class="privacy-content" v-if="content" v-html="content"></div>
    <div class="loading" v-else>加载中...</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content: "",
      isDisabled: false,
    };
  },

  created() {
    this.loadPrivacy();
  },
  mounted() {
    
  },
  methods: {
    loadPrivacy() {
      // 不要重复点击
      if (this.isDisabled) {
        return false;
      }

      this.isDisabled = true;
      this.axios.getPrivacy().then((res) => {
        this.content = res.data;
        this.isDisabled = false;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.privacy-page {
  min-height: 100vh;
  background: #fff;
  padding: 40px 20px;
  
  .privacy-header {
    max-width: 1200px;
    margin: 0 auto 0;
    text-align: center;
    
    h1 {
      font-size: 40px;
      color: #000;
      font-weight: bold;
      margin: 0;
      text-align: center;
    }
  }
  
  .privacy-content {
    max-width: 1200px;
    margin: 0 auto;
    line-height: 1.8;
    color: #333;
    
    ::v-deep h1,
    ::v-deep h2,
    ::v-deep h3 {
      margin-top: 20px;
      margin-bottom: 10px;
      color: #000;
    }
    
    ::v-deep p {
      margin-bottom: 10px;
    }
    
    ::v-deep ul,
    ::v-deep ol {
      padding-left: 20px;
      margin-bottom: 10px;
    }
  }
  
  .loading {
    text-align: center;
    padding: 100px 0;
    font-size: 16px;
    color: #999;
  }
}
</style>
